import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  IJobEstimateApproveClick,
  IEstimateFile,
  IJobEstimateViewClick,
} from './job-estimate-preview.data';

@Component({
  selector: 'i2g-job-estimate-preview',
  templateUrl: 'job-estimate-preview.component.html',
  styleUrls: ['job-estimate-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobEstimatePreviewComponent {
  @Input() file: IEstimateFile;
  @Input() approveButtonText: string;
  @Input() viewButtonText: string;
  @Input() bannerText: string;
  @Output() approveClick = new EventEmitter<IJobEstimateApproveClick>();
  @Output() viewClick = new EventEmitter<IJobEstimateViewClick>();

  onApproveClicked() {
    const { documentId, documentNumber } = this.file;

    this.approveClick.emit({
      documentId,
      documentNumber,
    });
  }

  onViewClicked() {
    const { documentId } = this.file;

    this.viewClick.emit({
      documentId,
    });
  }
}
